// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__DzA+w","row":"NoData_row__meMax","button":"NoData_button__2hxPZ"};